// Desktop console palette — mirrors the mobile admin theme so screenshots
// and mental models stay portable between the two surfaces.
export const COLORS = {
  bg:            '#0A0B0D',
  surface:       '#111318',
  surfaceAlt:    '#171A21',
  border:        '#22262E',
  borderStrong:  '#2E333D',
  text:          '#E7E9EE',
  textSecondary: '#B0B6C1',
  textMuted:     '#7A8290',
  accent:        '#A3E635',
  success:       '#3ECF8E',
  warn:          '#F7B955',
  critical:      '#E5484D',
  info:          '#7CB7FF',
} as const;

export const RADIUS = {
  card: 12,
  input: 8,
  chip: 999,
} as const;

export function healthColor(score: number): string {
  if (score >= 85) return COLORS.success;
  if (score >= 60) return COLORS.warn;
  return COLORS.critical;
}
